/**
 * @category Internal
 */
export var TypeGuard;
(function (TypeGuard) {
    /**
     * Checks if the given object is an instance of the indicated class.
     *
     * @param o the object to be checked.
     * @param className the name of the class to check for.
     */
    TypeGuard.typeGuard = function (o, className) {
        return o instanceof className;
    };
})(TypeGuard || (TypeGuard = {}));
